const IS_DEVELOPER = true;

const PROD_URL_HEAD = 'http://myapi.local:5010/';
const DEV_URL_HEAD = 'https://flabs-test.fluxionsolution.com/';

const development = IS_DEVELOPER;
let urls;

if (development) {
  urls = {
    BASE_URL: DEV_URL_HEAD,
  };
} else {
  urls = {
    BASE_URL: PROD_URL_HEAD,
  };
}

export const { BASE_URL } = urls;

export const LOGIN = 'api/0102/getAuthenticated';
export const POST_MASTER_DATA = 'api/0202/postMasterData';
export const GET_MASTER_DATA = 'api/0202/getMasterData';
export const PUT_MASTER_DATA = 'api/0202/putMasterData';
export const POST_TEST = 'api/0202/postTestMaster';
export const POST_TEST_BULK = 'api/0202/postTestMasterBulk';
export const POST_GROUP_MASTER_BULK = 'api/0202/postTestGroupMasterBulk';
export const POST_DEFAULT_VALUES = 'api/0202/postTestDefaultValue';
export const POST_DEVICE_CONFIG_BULK = 'api/0202/postDeviceConfigBulk';
export const GET_DEVICE_CONFIG = 'api/0202/getDeviceConfig';
export const DELETE_DEVICE_CONFIG = 'api/0202/deleteDeviceConfig';
export const PUT_SUBSCRIPTION_EXPIRY_DATE = 'api/0202/putSubscriptionExpiryDate';
export const POST_MODULES = 'api/roles/postModules';
export const GET_SUBSCRIPTION_EXPIRY_DATE = 'api/0102/getSubscriptionExpiryDate';